import { gql } from '@apollo/client';

import { TemplateMetadata } from './types';

export const USE_TEMPLATE_HOOK_QUERY = gql`
  query TemplateQuery($id: Long!) {
    template(id: $id) {
      id
      name
    }
  }
`;

export const USE_TEMPLATES_HOOK_QUERY = gql`
  query TemplatesQuery($search: String!, $pagination: Pagination!, $sort: Sort!) {
    templates(search: $search, pagination: $pagination, sort: $sort) {
      results {
        id
        name
      }
    }
  }
`;

export const TEMPLATE_METADATA_FRAGMENT = gql`
  fragment TemplateMetadata on Template {
    id
    name
  }
`;

export const DEFAULT_TEMPLATES: TemplateMetadata[] = [];
